// extracted by mini-css-extract-plugin
export default {"notification":"EmptyProfile_notification--DxX","link":"EmptyProfile_link--O__"};